/* Luna Segura · regalo por monto (código propio, independiente del tema).
   Al llegar a la meta (window.LSGift.goal, en centavos) agrega la bolsita transportadora (producto a $0)
   y la quita si el total baja de la meta. Una sola pieza por pedido.
   Si el producto de regalo no existe / no está publicado, no hace nada. */
(function () {
  'use strict';
  var C = window.LSGift;
  if (!C) return;

  // Bandera de pruebas (solo en el navegador de quien la activa): localStorage.lsGiftBeta = '1'
  var beta = false, testIds = [];
  try {
    beta = localStorage.getItem('lsGiftBeta') === '1';
    var t = localStorage.getItem('lsGiftTest');
    if (t) testIds = t.split(',').map(Number).filter(Boolean);
  } catch (e) {}
  if (beta) document.documentElement.classList.add('ls-gift-beta');

  var real = C.variantIds && C.variantIds.length;
  var ids = real ? C.variantIds : (beta ? (testIds.length ? testIds : [39948880117898, 39948880150666]) : []);
  var defaultVariant = real ? C.defaultVariant : (ids[0] || 0);
  if (!ids.length || !defaultVariant) return;

  var busy = false, timer = null, internal = 0;

  function pref() { try { var v = Number(localStorage.getItem('lsGiftColor')); return ids.indexOf(v) > -1 ? v : defaultVariant; } catch (e) { return defaultVariant; } }
  function setPref(v) { try { localStorage.setItem('lsGiftColor', String(v)); } catch (e) {} }

  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) {} return null; }

  function post(url, body) {
    internal++;
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (x) { internal--; return x; }, function (e) { internal--; throw e; });
  }

  function refreshUI() {
    if (typeof window.LSRefreshCartDrawer === 'function') { try { window.LSRefreshCartDrawer(); } catch (e) {} }
    if (location.pathname.replace(/\/$/, '') === '/cart') { location.reload(); }
  }

  function sync() {
    if (busy) return;
    busy = true;
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var gift = cart.items.filter(function (i) { return ids.indexOf(i.variant_id) > -1; });
        var rest = cart.items.filter(function (i) { return ids.indexOf(i.variant_id) === -1; })
          .reduce(function (s, i) { return s + i.final_line_price; }, 0);
        var eligible = rest >= C.goal;
        var job = null;

        if (eligible) {
          if (gift.length === 0) {
            if (ss('lsGiftAdded') === '1') { ss('lsGiftOptOut', '1'); ss('lsGiftAdded', null); }   // la clienta lo quitó
            if (ss('lsGiftOptOut') !== '1') {
              job = post('/cart/add.js', { items: [{ id: pref(), quantity: 1, properties: { _regalo: 'meta' } }] })
                .then(function (x) { if (x.ok) ss('lsGiftAdded', '1'); return x.ok; });
            }
          } else {
            ss('lsGiftAdded', '1');
            var qty = gift.reduce(function (s, i) { return s + i.quantity; }, 0);
            if (gift.length > 1 || qty > 1) {   // una sola pieza
              job = post('/cart/change.js', { id: gift[0].key, quantity: 1 }).then(function () {
                return gift.slice(1).reduce(function (p, l) { return p.then(function () { return post('/cart/change.js', { id: l.key, quantity: 0 }); }); }, Promise.resolve());
              }).then(function () { return true; });
            }
          }
        } else {
          ss('lsGiftOptOut', null);
          if (gift.length > 0) {   // bajó de la meta: se quita el regalo
            ss('lsGiftAdded', null);
            job = gift.reduce(function (p, l) { return p.then(function () { return post('/cart/change.js', { id: l.key, quantity: 0 }); }); }, Promise.resolve()).then(function () { return true; });
          }
        }
        return job ? job.then(function (changed) { if (changed) refreshUI(); }) : null;
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function schedule() { clearTimeout(timer); timer = setTimeout(sync, 350); }

  // Elegir color del regalo
  function paintChips() {
    var cur = pref();
    document.querySelectorAll('.lsg__color').forEach(function (b) {
      var vid = Number(b.getAttribute('data-lsg-variant'));
      var inCart = b.closest('.lsg__card') && b.closest('.lsg__card').classList.contains('is-unlocked') && document.querySelector('.cart-item--gift');
      // si el regalo ya está en el carrito, manda la variante del carrito (la marca el servidor)
      if (inCart) return;
      var on = vid === cur;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function chooseColor(vid) {
    setPref(vid);
    paintChips();
    if (busy) return;
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var gift = cart.items.filter(function (i) { return ids.indexOf(i.variant_id) > -1; });
        if (!gift.length) { ss('lsGiftOptOut', null); return false; }            // aún no está: se agregará con este color
        if (gift.length === 1 && gift[0].variant_id === vid && gift[0].quantity === 1) return false;
        var chain = gift.reduce(function (p, l) { return p.then(function () { return post('/cart/change.js', { id: l.key, quantity: 0 }); }); }, Promise.resolve());
        return chain.then(function () { return post('/cart/add.js', { items: [{ id: vid, quantity: 1, properties: { _regalo: 'meta' } }] }); })
          .then(function (x) { if (x.ok) ss('lsGiftAdded', '1'); return true; });
      })
      .catch(function () { return false; })
      .then(function (changed) { busy = false; if (changed) refreshUI(); else schedule(); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.lsg__color');
    if (!b) return;
    if (b.disabled) { e.preventDefault(); return; }   // se activa al llegar a la meta
    e.preventDefault(); e.stopPropagation();
    var vid = Number(b.getAttribute('data-lsg-variant'));
    if (vid) chooseColor(vid);
  }, true);

  // Re-pintar la selección cada vez que el cajón se vuelve a dibujar
  var mo = null;
  function watchDrawer() {
    var d = document.querySelector('cart-drawer');
    if (!d || mo) return;
    mo = new MutationObserver(function () { clearTimeout(mo._t); mo._t = setTimeout(paintChips, 60); });
    mo.observe(d, { childList: true, subtree: true });
    paintChips();
  }
  document.addEventListener('DOMContentLoaded', watchDrawer);
  if (document.readyState !== 'loading') watchDrawer();

  // Escucha cualquier cambio del carrito (fetch o XHR) sin depender del tema
  function isCartCall(url) { return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url || ''); }
  if (window.fetch) {
    var of = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url);
      var p = of.apply(this, arguments);
      if (!internal && isCartCall(url)) p.then(schedule, schedule);
      return p;
    };
  }
  if (window.XMLHttpRequest) {
    var oo = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, url) {
      var self = this;
      if (!internal && isCartCall(String(url))) this.addEventListener('loadend', schedule);
      return oo.apply(this, arguments);
    };
  }
  document.addEventListener('DOMContentLoaded', function () {
    schedule();
    try { if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) subscribe(PUB_SUB_EVENTS.cartUpdate, schedule); } catch (e) {}
  });
  if (document.readyState !== 'loading') schedule();
  window.LSGiftSync = sync;
})();
